// extracted by mini-css-extract-plugin
export var anchor = "cartSummary-module--anchor--d7c3b";
export var checkoutButton = "cartSummary-module--checkoutButton--32a5f";
export var checkoutDetails = "cartSummary-module--checkoutDetails--e62ff";
export var checkoutInfoMarginTop = "cartSummary-module--checkoutInfoMarginTop--2d5ee";
export var checkoutMargin = "cartSummary-module--checkoutMargin--fa0cf";
export var currency = "cartSummary-module--currency--a5b6b";
export var deliveryDiscountMessage = "cartSummary-module--deliveryDiscountMessage--a2cc2";
export var deliveryMethod = "cartSummary-module--deliveryMethod--3bb50";
export var desktopOnlyMod = "cartSummary-module--desktopOnlyMod--d5374";
export var divDeliveryInfo = "cartSummary-module--divDeliveryInfo--8cbc2";
export var divider = "cartSummary-module--divider--3cfbf";
export var dividerBlack = "cartSummary-module--dividerBlack--46533";
export var form = "cartSummary-module--form--fd3b6";
export var grandTotal = "cartSummary-module--grandTotal--4911a";
export var gridMenu = "cartSummary-module--gridMenu--604a7";
export var header = "cartSummary-module--header--9ff1d";
export var headerMod = "cartSummary-module--headerMod--db09d";
export var icon = "cartSummary-module--icon--2ae60";
export var italic = "cartSummary-module--italic--4c4e3";
export var item = "cartSummary-module--item--24100";
export var label = "cartSummary-module--label--5c90e";
export var mainButton = "cartSummary-module--mainButton--89e2e";
export var menuBorder = "cartSummary-module--menuBorder--da0d3";
export var menuItem = "cartSummary-module--menuItem--5ccd6";
export var menuItemMessage = "cartSummary-module--menuItemMessage--7f9cf";
export var mobileOnlyMod = "cartSummary-module--mobileOnlyMod--fae7f";
export var msg = "cartSummary-module--msg--9b903";
export var overallDiv = "cartSummary-module--overallDiv--66ab0";
export var pickUpLink = "cartSummary-module--pickUpLink--ab5ad";
export var sectionPaddingTop = "cartSummary-module--sectionPaddingTop--e65ad";
export var text = "cartSummary-module--text--9fee0";
export var textAlignRight = "cartSummary-module--textAlignRight--a606c";